import React, { useState } from "react";
import "../styles/trophy.css";

const ToniKroosTrophies = () => {
  const [activeFilter, setActiveFilter] = useState("all");

  // Trophy data grouped by trophy name with years and team
  const trophyGroups = [
    {
      name: "UEFA Champions League",
      count: 5,
      years: [2016, 2017, 2018, 2022, 2024],
      team: "Real Madrid",
      category: "club",
      icon: "ucl",
      color: "#0E1E5B",
    },
    {
      name: "UEFA Champions League",
      count: 1,
      years: [2013],
      team: "Bayern Munich",
      category: "club",
      icon: "ucl",
      color: "#0E1E5B",
    },
    {
      name: "La Liga",
      count: 4,
      years: [2017, 2020, 2022, 2024],
      team: "Real Madrid",
      category: "club",
      icon: "laliga",
      color: "#ee324e",
    },
    {
      name: "FIFA Club World Cup",
      count: 5,
      years: [2014, 2016, 2017, 2018, 2022],
      team: "Real Madrid",
      category: "club",
      icon: "clubwc",
      color: "#003f5f",
    },
    {
      name: "FIFA Club World Cup",
      count: 1,
      years: [2013],
      team: "Bayern Munich",
      category: "club",
      icon: "clubwc",
      color: "#003f5f",
    },
    {
      name: "UEFA Super Cup",
      count: 5,
      years: [2014, 2016, 2017, 2022, 2023],
      team: "Real Madrid",
      category: "club",
      icon: "supercup",
      color: "#120f38",
    },
    {
      name: "Copa del Rey",
      count: 1,
      years: [2023],
      team: "Real Madrid",
      category: "club",
      icon: "copa",
      color: "#9C8B56",
    },
    {
      name: "Supercopa de España",
      count: 4,
      years: [2017, 2020, 2022, 2024],
      team: "Real Madrid",
      category: "club",
      icon: "supercopa",
      color: "#9C8B56",
    },
    {
      name: "German Bundesliga",
      count: 3,
      years: [2008, 2013, 2014],
      team: "Bayern Munich",
      category: "club",
      icon: "bundesliga",
      color: "#d20515",
    },
    {
      name: "German Cup (DFB-Pokal)",
      count: 3,
      years: [2008, 2013, 2014],
      team: "Bayern Munich",
      category: "club",
      icon: "dfb",
      color: "#191919",
    },
    {
      name: "FIFA World Cup",
      count: 1,
      years: [2014],
      team: "Germany",
      category: "international",
      icon: "worldcup",
      color: "#deb405",
    },
    {
      name: "German Super Cup",
      count: 1,
      years: [2012],
      team: "Bayern Munich",
      category: "club",
      icon: "germansupercup",
      color: "#d20515",
    },
  ];

  // Filter trophies based on selected category
  const filteredTrophies =
    activeFilter === "all"
      ? trophyGroups
      : trophyGroups.filter((trophy) => trophy.category === activeFilter);

  // Sort by trophy count (descending)
  const sortedTrophies = [...filteredTrophies].sort(
    (a, b) => b.count - a.count,
  );

  // Calculate total trophies count
  const totalTrophiesCount = trophyGroups.reduce(
    (total, trophy) => total + trophy.count,
    0,
  );
  const clubTrophiesCount = trophyGroups
    .filter((trophy) => trophy.category === "club")
    .reduce((total, trophy) => total + trophy.count, 0);
  const internationalTrophiesCount = trophyGroups
    .filter((trophy) => trophy.category === "international")
    .reduce((total, trophy) => total + trophy.count, 0);

  const teamGroups = ["Real Madrid", "Bayern Munich", "Germany"]
    .map((team) => ({
      team,
      trophies: sortedTrophies.filter((trophy) => trophy.team === team),
    }))
    .filter((group) => group.trophies.length > 0);

  return (
    <div className="trophy-showcase">
      <div className="trophy-overview" aria-label="Trophy totals">
        <div className="overview-stat overview-stat--total">
          <span className="overview-value">{totalTrophiesCount}</span>
          <span className="overview-label">Titles won</span>
        </div>
        <div className="overview-stat">
          <span className="overview-value">{clubTrophiesCount}</span>
          <span className="overview-label">Club titles</span>
        </div>
        <div className="overview-stat">
          <span className="overview-value">{internationalTrophiesCount}</span>
          <span className="overview-label">International</span>
        </div>
      </div>

      <div className="trophy-toolbar">
        <h1 className="collection-title">Honours by team</h1>
        <div className="filter-tabs" role="group" aria-label="Filter trophies">
          <button
            type="button"
            className={`filter-tab ${activeFilter === "all" ? "active" : ""}`}
            aria-pressed={activeFilter === "all"}
            onClick={() => setActiveFilter("all")}
          >
            All Trophies
          </button>
          <button
            type="button"
            className={`filter-tab ${activeFilter === "club" ? "active" : ""}`}
            aria-pressed={activeFilter === "club"}
            onClick={() => setActiveFilter("club")}
          >
            Club
          </button>
          <button
            type="button"
            className={`filter-tab ${
              activeFilter === "international" ? "active" : ""
            }`}
            aria-pressed={activeFilter === "international"}
            onClick={() => setActiveFilter("international")}
          >
            International
          </button>
        </div>
      </div>

      {teamGroups.map(({ team, trophies }) => (
        <section
          className="team-section"
          key={team}
          aria-labelledby={`team-${team}`}
        >
          <div className="team-heading">
            <h2 id={`team-${team}`}>{team}</h2>
            <span>
              {trophies.reduce((total, trophy) => total + trophy.count, 0)}{" "}
              titles
            </span>
          </div>
          <div className="trophies-grid">
            {trophies.map((trophy) => (
              <article
                key={`${trophy.team}-${trophy.name}`}
                className="trophy-card"
                style={{ "--trophy-color": trophy.color }}
              >
                <div className="trophy-card-header">
                  <h3 className="trophy-name">{trophy.name}</h3>
                  <span className="trophy-count">
                    {trophy.count}
                    <small>x</small>
                  </span>
                </div>

                <div className="trophy-icon-container" aria-hidden="true">
                  <div className={`trophy-icon ${trophy.icon}`}></div>
                </div>

                <div className="trophy-details">
                  <div
                    className="trophy-years"
                    aria-label={`Won in ${trophy.years.join(", ")}`}
                  >
                    {trophy.years.map((year) => (
                      <span key={year} className="year-tag">
                        {year}
                      </span>
                    ))}
                  </div>
                </div>
              </article>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
};

export default ToniKroosTrophies;
